exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-donate-tsx": () => import("./../../../src/pages/donate.tsx" /* webpackChunkName: "component---src-pages-donate-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-media-inquiry-tsx": () => import("./../../../src/pages/media-inquiry.tsx" /* webpackChunkName: "component---src-pages-media-inquiry-tsx" */),
  "component---src-pages-write-letter-tsx": () => import("./../../../src/pages/write-letter.tsx" /* webpackChunkName: "component---src-pages-write-letter-tsx" */)
}

